import { memoize } from 'lodash';

export default () => {
  return memoize(link => {
    link = link || '';
    return link.indexOf('://') === -1 ? `http://${link}` : link;
  });
};
